
import ApiService from "./ApiService"

export async function apiGetEmailTemplate(data) {
    return ApiService.fetchData({
        url: '/EmailTemplate/GetEmailTemplates',
        method: 'get',
        data
    })
}

export async function apiGetEmailTemplateAsync (data) {
    return ApiService.fetchData({
        url: '/EmailTemplate/GetEmailTemplatesAsync',
        method: 'post',
        data
    })
}

export async function apiCreateEmailTemplate (data) {
    return ApiService.fetchData({
        url: '/EmailTemplate/CreateEmailTemplate',
        method: 'post',
        data
    })
}

export async function apiGetEmailTemplateById(params) {
    return ApiService.fetchData({
        url: '/EmailTemplate/GetEmailTemplateById',
        method: 'get',
        params
    })
}

export async function apiEditEmailTemplate(data) {
    return ApiService.fetchData({
        url: '/EmailTemplate/UpdateEmailTemplate',
        method: 'put',
        data
    })
}

export async function apiDeleteEmailTemplate(params) {
    return ApiService.fetchData({
        url: '/EmailTemplate/DeleteEmailTemplate',
        method: 'delete',
        params
    })
}

//EmailTemplateItem
export async function apiGetEmailTemplateItems(params) {
    return ApiService.fetchData({
        url: '/EmailTemplate/GetEmailTemplateItems',
        method: 'get',
        params
    })
}

export async function apiGetEmailTemplateItemsAsync (data) {
    return ApiService.fetchData({
        url: '/EmailTemplate/GetEmailTemplateItemsAsync',
        method: 'post',
        data
    })
}

export async function apiGetEmailTemplateItemById(params) {
    return ApiService.fetchData({
        url: '/EmailTemplate/GetEmailTemplatItemById',
        method: 'get',
        params
    })
}

export async function apiCreateEmailTemplateItem (data) {
    return ApiService.fetchData({
        url: '/EmailTemplate/CreateEmailTemplateItem',
        method: 'post',
        data
    })
}

export async function apiUpdateEmailTemplateItem (data) {
    return ApiService.fetchData({
        url: '/EmailTemplate/UpdateEmailTemplateItem',
        method: 'put',
        data
    })
}

export async function apiDeleteEmailTemplateItem(params) {
    return ApiService.fetchData({
        url: '/EmailTemplate/DeleteEmailTemplateItem',
        method: 'delete',
        params
    })
}
